export const postWorkCenterLocationCollaboratorInitialState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
